import React, { useState, useEffect, useRef } from "react";
import bannerImg from "../assets/images/House5.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowRightLong,
  faAward,
  faBath,
  faBed,
  faEnvelope,
  faLocationDot,
  faMagnifyingGlass,
  faPhone,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import avatar1 from "../assets/images/avatar1.png";
import avatar2 from "../assets/images/avatar3.png";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link } from "react-router-dom";
import imgs from "./temp.json";
import ReactImageGallery from "react-image-gallery";
import calc from "../assets/images/shutterstock_2489188913-min.jpg";
import report from "../assets/images/shutterstock_699442570-min.jpg";
import house from "../assets/images/shutterstock_2384875071-min.jpg";
import constants from "../constants/constants";
import DEMO_LISTINGS from "../constants/demoListings";
import video from "../assets/images/2110972-uhd_3840_2160_30fps.mp4";
// import video from '../assets/images/1107548377-preview.mp4'
import formattingFunctions from "../functions/formatting";
import houseInterior from "../assets/images/shutterstock_2304013113-min.jpg";
// import houseInterior from "../assets/images/stock-photo-luxury-hotel-bathroom-interior-with-bathtub-and-side-table-concrete-floor-bathing-space-in-modern-2467634645.jpg"

import houseInterior2 from "../assets/images/shutterstock_1935730303-min.jpg";

import pageSEO from "../constants/pageSEO";
import { SEO } from "../components/seo.component";
import isReactSnap from "../utils/isReactSnap";
import globalState from "../utils/globalState";
import { useUserParams } from "../hooks/useUserParams";

// Dynamically import all images from the images folder
const imageContext = require.context("../assets/images", false, /\.(jpg|jpeg|png|webp)$/);
const imageMap = {};
imageContext.keys().forEach((item) => {
  const imageName = item.replace("./", "");
  imageMap[imageName] = imageContext(item);
});

// Function to get the first image that contains the ListingKey in its filename
const getFirstImageByListingKey = (listingKey) => {
  if (!listingKey) {
    return placeholder;
  }

  // Find all image files that contain the ListingKey in their name
  const matchingImages = Object.keys(imageMap)
    .filter((imageName) => imageName.includes(listingKey))
    .map((imageName) => ({
      path: imageMap[imageName],
      filename: imageName,
    }))
    .sort((a, b) => {
      // Sort: main photo first, then others alphabetically
      if (a.filename.includes("main photo")) return -1;
      if (b.filename.includes("main photo")) return 1;
      return a.filename.localeCompare(b.filename);
    });

  // Return the first matching image, or placeholder if none found
  return matchingImages.length > 0 ? matchingImages[0].path : placeholder;
};

export default function Homepage() {
  const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  const testimonials = [
    {
      quote:
        "He is really good sds sf sdf sfsdf sdfsf sdfsdf sf sdfs dfs fsd fsfd fsd fsdf sdfsfds sdfs fsf sdfs dfsfdsdf sdfdsfs fsdffsd sdfsdfsf sdfsdf sdfsfsdfsdf sdfsdf sdfsdfsdf sdfsdfsdf",
      name: "Larry Ross",
      image: avatar1,
    },
    { quote: "Best realtor ever", name: "Sylvia Jones", image: avatar2 },
  ];
  const contact = useRef();
  const temp = [
    { CityRegion: "Beaches", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Leslieville", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "Danforth", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
    { CityRegion: "High Park", Bedrooms: 4, Bathrooms: 3, ListPrice: 999000 },
  ];

  const [listings, setListings] = useState(DEMO_LISTINGS);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const loaded = useRef(false);
  const loadedRef = useRef(false);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [showDebug, setShowDebug] = useState(false);

  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentQuote,
    getCurrentAbout,
    getCurrentHeadshot,
  } = useUserParams();

  // Get userId from URL parameters
  const getURLParameters = () => {
    if (typeof window === "undefined") {
      return { userId: null };
    }
    const urlParams = new URLSearchParams(window.location.search);
    return {
      userId: urlParams.get("userId"),
    };
  };

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  function getData() {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: [] });
    }

    var body = {
      url: `https://query.ampre.ca/odata/Property?$filter=(ListAgentKey eq '${constants.AGENT_ID}' and StandardStatus eq 'Active')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`,
      needAuth: true,
      bearerToken: constants.TOKEN,
    };

    return new Promise(async (resolve, reject) => {
      try {
        let request = `odata/Property(Q)$filter=(ListAgentKey(S)eq(S)\'${constants.AGENT_ID}\'(S)and(S)StandardStatus(S)eq(S)\'Active\')(A)$orderby=OriginalEntryTimestamp(S)desc,ListingKey(A)$top=12`;


        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${request}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function getMedia(listings) {
    // Skip API calls during static generation
    if (isReactSnap() || !listings || listings.length === 0) {
      return Promise.resolve({ value: [] });
    }

    // this is for development
    //var temp = `https://query.ampre.ca/odata/Media?$filter=(`

    // this is for production
    // var temp = `odata/Media?$filter=(`

    if (constants.ENVIRONMENT === "development") {
      var temp = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "', ";
      }
      temp = temp.slice(0, -2);
      temp =
        temp +
        ") and ImageSizeDescription eq 'Medium' and PreferredPhotoYN eq true";
    } else {
      var temp = `odata/Media(Q)$filter=ResourceRecordKey(S)in(S)(`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      temp = temp.slice(0, -1);
      temp =
        temp +
        ")(S)and(S)ImageSizeDescription(S)eq(S)'Medium'(S)and(S)PreferredPhotoYN(S)eq(S)true";
    }
    var body = {
      url: temp,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9sZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };

    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "production"
            ? await fetch(`https://${constants.DOMAIN}/api/${temp}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-Type": "application/json",
              },
            });

        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    return temp;
  }

  // Function to fetch template settings from MongoDB
  const fetchTemplateSettings = async (userId) => {
    try {
      const apiKey = process.env.REACT_APP_API_KEY;
      const response = await fetch(`https://agent.proagentsolutions.com/MongoDB/GetTemplateSettingsByUserId?userId=${userId}&apiKey=${apiKey}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const templateSettings = await response.json();
      console.log("Template settings fetched:", templateSettings);

      if (templateSettings) {
        const settingsData = templateSettings.data || templateSettings;

        const mappedUserData = {
          userId,
          agentName: settingsData.agentName || settingsData.AGENT_NAME,
          agentTitle: settingsData.agentTitle || settingsData.AGENT_TITLE,
          agentNumber: settingsData.agentNumber || settingsData.AGENT_NUMBER,
          agentEmail: settingsData.agentEmail || settingsData.AGENT_EMAIL,
          brokerage: settingsData.brokerage || settingsData.BROKERAGE,
          // Preserve additional settings for downstream use
          ...settingsData,
        };

        globalState.setUserData(mappedUserData);

        console.log("Template settings data:", settingsData);
        console.log("Template settings mapped to user data:", mappedUserData);
      }

      return templateSettings;
    } catch (error) {
      console.error("Error fetching template settings:", error);
      return null;
    }
  };

  useEffect(() => {
    if (!loaded.current) {
      const urlParams = getURLParameters();
      if (urlParams.userId) {
        globalState.setUserId(urlParams.userId);

        fetchTemplateSettings(urlParams.userId).then(() => {
          console.log(
            "Global State Updated with Template Settings:",
            globalState.getDebugInfo()
          );
        });

        console.log("Global State Updated:", globalState.getDebugInfo());
      }

      var temp1 = [];
      getData()
        .then((data) => {
          const remoteListings = data?.value ?? [];

          if (remoteListings.length) {
            setListings(remoteListings);
            getMedia(remoteListings)
              .then((d) => {
                setMedia(d.value);
                temp1 = d.value;
                setFormatted(formatMedia(d.value));
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            setListings(DEMO_LISTINGS);
          }
        })
        .catch((err) => {
          console.log(err);
          setListings(DEMO_LISTINGS);
        });

      // getMedia().then(data => {
      //     console.log(data)
      //     setMedia(data.value)

      // }).catch(err => {
      //     console.log(err);
      // })
      // var temp = {}

      // for (let img of temp1) {
      //     if (temp[img.ResourceRecordKey]) {
      //         temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img]
      //     } else {
      //         temp[img.ResourceRecordKey] = [img]

      //     }
      // }
      // console.log(temp)
      // setFormatted(temp);
      loaded.current = true;
    }
  }, []);

  function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    str = str
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
    return str;
  }

  const [keyword, setKeyword] = useState("");

  const seoConfig = pageSEO.home();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="bg-[#F0EEE0]">
        <div className="h-[100vh] w-full absolute  bg-black overflow-hidden">
          <img
            src={constants.HOME_IMAGE}
            className="w-full h-full opacity-30 object-cover"
          />
        </div>

        <div className="w-full  h-[100vh] relative bg-cover z-10">
          {/* <div className="p-12 bg-logo-main w-min absolute top-[30%] left-[10%]">
                    <h1 className="text-white text-3xl sm:text-5xl font-mont">NICK </h1>
                    <h1 className="text-white text-3xl sm:text-5xl font-mont">LASTNAME</h1>
                    <h4 className="text-white text-xl font-mont mt-5 whitespace-normal">Real Estate Agent, TREB</h4>

                </div> */}
          <div className="mx-auto md:w-[80%] lg:w-[40%] pt-[35%] md:pt-[25%] lg:pt-[15%] px-5">
            <h1 className="text-7xl text-center pb-12 libre text-white tracking-wide">
              Experience You Can Trust
            </h1>
            <div className="flex gap-6 justify-center">
              {/* <div className="relative flex-1">
                            <input className="form-input" placeholder="Search Keyword" value={keyword} onChange={(e) => setKeyword(e.target.value)} style={{ borderRadius: '99999px' }}></input>
                            <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute right-4 top-2 text-med-grey" />
                        </div> */}
              <Link>
                <button
                  onClick={() => contact.current?.scrollIntoView()}
                  className="btn-primary"
                >
                  Contact Me
                </button>
              </Link>
              <Link to={"/listings"}>
                <button className="btn-tertiary">See Listings</button>
              </Link>
            </div>
          </div>
        </div>
        <div className=" bg-logo-second w-full">
          {/* <h1 className="text-4xl text-white py-10 font-mont px-10 uppercase pt-14 max-w-[1700px] mx-auto">Featured Neighbourhoods</h1>

                <div className="grid min-[750px]:grid-cols-2 px-10 max-w-[1700px] mx-auto">
                    {constants.LOCATIONS.slice(0, 4).map((location) =>
                        <Link to={`location/${formattingFunctions.slugify(location.name)}`}>
                            <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                                <img className="absolute h-full  object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={location.img} />
                                <h1 className="text-3xl  text-white py-8 font-mont px-10 uppercase z-10">{location.name}</h1>

                            </div>
                        </Link>
                    )}


                </div> */}
          <div
            className="px-10  min-[900px]:grid py-32 -z-10"
            style={{ gridTemplateColumns: "40% 60%" }}
          >
            <div className="flex items-center flex-col gap-y-4 z-20 relative">
              <div className="max-[450px]:w-[110%] absolute z-10 h-[40vh] w-[85%] bg-logo-third -mt-16 border-gradient-2"></div>
              <div className="max-[450px]:max-w-[100%] max-w-[70%] lg:max-w-[20vw] max-h-[50vh]  aspect-[3/4] overflow-clip z-30 mx-4 mb-12">
                <img
                  src={getCurrentHeadshot()}
                  className="h-full w-full object-cover border-gradient-2"
                />
              </div>
            </div>
            <div className="flex flex-col text-white text-xl min-[900px]:pr-[30%] z-20 relative">
              <h1 className="text-5xl  text-white pb-8  libre tracking-wide z-10 mb-3">
                Your Trusted Realtor
              </h1>

              {getCurrentAbout() ? (
                getCurrentAbout()
                  .split("<|>")
                  .map((p, index) => (
                    <p key={index}>
                      {p}
                      <br />
                      <br />
                    </p>
                  ))
              ) : (
                <p>Coming Soon</p>
              )}
              <div className="flex gap-x-4">
                {/* <btn onClick={() => contact.current.scrollIntoView()} className='btn-primary self-start mt-5 '>CONTACT US</btn> */}
                <Link className="btn-tertiary self-start mt-5 " to={"/about"}>
                  <btn>Why Choose {getCurrentAgentName()?.split(" ")[0]}</btn>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* <div className=" pb-24 bg-slate-800">

                <div className="flex justify-between items-center mx-auto max-w-[1500px] px-7 ">

                    <h1 className="text-4xl text-white py-8 font-mont ">OUR AGENTS</h1>
                    <Link className="underline font-semibold underline-offset-4 text-white" to={"/agents"}>View All</Link>
                </div>
                <div className='mx-auto max-w-[1500px] px-7 h-[40vh] sm:h-[30vh] md:h-[45vh]' >

                    <Swiper
                        style={{ "--swiper-pagination-color": "white", "--swiper-button-prev": 'white', '--swiper-pagination-bullet-inactive-color': '#f1f1f1', '--swiper-theme-color': 'lightgrey' }}
                        slidesPerView={1}
                        spaceBetween={50}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        loop={true}
                        loopPreventsSliding={true}

                        autoplay={{
                            delay: 7500,
                            disableOnInteraction: true,
                            pauseOnMouseEnter: true
                        }}
                        modules={[Pagination, Autoplay, Navigation]}
                        breakpoints={{

                            640: {
                                spaceBetween: 30,
                                slidesPerView: 2
                            },
                            950: {
                                spaceBetween: 50,
                                slidesPerView: 3
                            },

                        }}


                    >

                        {
                            constants.AGENTS?.map((agent, index) =>
                                <SwiperSlide key={index} >

                                    <div className=' h-[40vh] sm:h-[30vh] md:h-[45vh]' >
                                        <Link className="w-full " state={agent} to={`agents/${slugify(agent.name)}`}>
                                            <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden group">
                                                <img className="w-full h-full object-cover" src={agent.img ?? placeholder} />
                                                <div className="px-4 py-2 duration-1000 h-[100px] bg-logo-second bg-opacity-50 absolute bottom-0 w-full text-white group-hover:h-full">
                                                    <p className="text-xl font-mont font-semibold">{agent.name}</p>
                                                    <p className=" italic">{agent.title}</p>
                                                    <div className="flex gap-x-4 mt-2">
                                                        {Object.entries(agent.socials ?? {})?.map(([k, v], index) =>
                                                            <a href={v}>
                                                                <FontAwesomeIcon className="fa-lg" icon={constants.ICONS[k]} />

                                                            </a>
                                                        )}
                                                    </div>
                                                    <p className="mt-7 text-xl font-semibold">About {agent.name?.split(' ')[0]}</p>
                                                    <p className="mt-3">{agent.bio ? agent.bio.replace(/(<([^>]+)>)/gi, '')?.split(' ')?.splice(0, windowSize > 950 && windowSize < 1500 ? 20 : 50)?.join(' ') + " ..." : 'Coming Soon'}</p>
                                                </div>
                                            </div>

                                        </Link>
                                    </div>
                                </SwiperSlide>


                            )
                        }

                    </Swiper>
                </div>
                <div className="grid mx-auto mt-12 sm:grid-cols-3 w-fit gap-x-12 gap-y-12 child:max-w-64 child:flex child:flex-col child:gap-y-5 child:text-center ">
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey " />
                        <span className="text-med-grey font-semibold text-2xl">2022</span>
                        <span className="text-white font-semibold text-xl">Best Realtor Toronto</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faStar} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2023</span>
                        <span className="text-white font-semibold text-xl">Most Houses Sold</span>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faAward} className="fa-5x text-med-grey" />
                        <span className="text-med-grey font-semibold text-2xl">2019</span>
                        <span className="text-white font-semibold text-xl">Favourite Realtor </span>
                    </div>





                </div>
              
            </div> */}
        <div className="bg-logo-main px-10">
          {/* <h1 className="text-4xl text-white py-10 pt-20 font-mont text-center uppercase">Unsure about the next step? Let us help</h1>

                <div className="py-10 grid grid-cols-2 gap-24 max-w-[1000px] mx-auto">
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am looking to buy</h1>

                    </div>
                    <div className="h-[40vh] relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-75 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={house} />
                        <h1 className="text-3xl  text-white py-8 font-mont px-14 text-center uppercase z-10">I am Looking to Sell</h1>

                    </div>


                </div> */}
          <div className="flex justify-between items-center pt-14 pb-10 max-w-[1300px] mx-auto">
            <h1 className="text-4xl text-logo-second  libre  md:px-7">
              Featured Listings
            </h1>
            <Link
              className="underline font-semibold underline-offset-4 whitespace-nowrap text-logo-second"
              to={"/listings"}
            >
              View All
            </Link>
          </div>
          {/* <div className="h-24 w-36 border-gradient-1"></div> */}
          <div className="  pb-12 max-w-[1300px] mx-auto md:px-7">
            {listings.slice(0, 4).map((prop) => (
              <div
                className="w-full grid sm:grid-cols-2 mb-12"
                to={`/listing/${prop.ListingKey}`}
              >
                <div className="min-h-[300px] max-h-[415px]">
                  <img
                    className="w-full h-full object-cover"
                    src={getFirstImageByListingKey(prop.ListingKey)}
                  />
                </div>
                <div
                  style={{ gridTemplateRows: "auto 1fr 1fr " }}
                  className="border-gradient grid  text-logo-second"
                >
                  <div className="flex flex-col justify-between border-gradient py-6 xl:py-12 px-4 ">
                    <div className="h-12 w-12 mb-[5%] rounded-full bg-logo-third text-logo-main flex items-center justify-center">
                      <FontAwesomeIcon className="fa-xl" icon={faLocationDot} />
                    </div>

                    <div className=" flex flex-col ">
                      <p className="libre text-3xl mb-3">
                        {prop?.StreetNumber} {prop?.StreetName}{" "}
                        {prop?.StreetSuffix}
                      </p>
                      <p className=" text-xl">{prop.CityRegion}</p>
                    </div>
                  </div>
                  <div className="border-gradient grid grid-cols-3 child:flex child:items-center">
                    <div className="border-r-2 px-4 border-[#F1DD91] libre text-xl">
                      {prop?.BedroomsTotal ? prop?.BedroomsTotal : "--"} Beds
                    </div>
                    <div className="border-r-2 px-4 border-[#F1DD91] libre text-xl">
                      {prop?.BathroomsTotalInteger
                        ? prop?.BathroomsTotalInteger
                        : "--"}{" "}
                      Baths
                    </div>
                    <div className="border-r-2 px-4 border-[#F1DD91] libre text-xl relative">
                      {prop?.LivingAreaRange ? prop.LivingAreaRange : "--"} Sqft
                      {/* <div className="h-12 w-12 rounded-full absolute right-4 translate-y-[-100%]  bg-logo-third text-logo-main flex items-center justify-center">
                                            <FontAwesomeIcon className="fa-xl" icon={faLocationDot} />
                                        </div> */}
                    </div>
                  </div>
                  <div className="border-gradient px-4 libre text-3xl flex items-center justify-between gap-x-3 flex-wrap">
                    <span className="py-2">
                      ${prop?.ListPrice?.toLocaleString()}
                    </span>
                    <Link to={`listing/${prop?.ListingKey}`}>
                      <btn className="btn-secondary whitespace-nowrap">
                        View {windowSize > 900 ? "Listing" : ""}
                      </btn>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 
                <h1 className="text-4xl text-logo-second py-10 pt-18  text-center libre">Unsure About The Next Step? Let Us Help</h1>

                <div className="py-10 pb-32 grid min-[750px]:grid-cols-2 min-[1100px]:gap-24 gap-12 max-w-[1000px] mx-auto">
                    <Link to={'/listings'} className="h-[40vh] bg-black relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-25 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={houseInterior} />
                        <h1 className="text-3xl  text-logo-main py-8 libre px-14 text-center uppercase z-10">I am looking to buy</h1>

                    </Link>
                    <Link to={'/evaluation'} className="h-[40vh] bg-black relative cursor-pointer overflow-hidden flex items-center justify-center">
                        <img className="absolute h-full object-cover opacity-25 hover:opacity-50 w-full top-[50%] translate-y-[-50%] hover:scale-105 duration-500 " src={houseInterior2} />
                        <h1 className="text-3xl  text-logo-main py-8 libre px-14 text-center uppercase z-10">I am Looking to Sell</h1>

                    </Link>


                </div> */}
        </div>
        <div className="w-full bg-logo-second ">
          <div className="flex flex-col md:block pt-10 md:pt-0  gap-10 child:overflow-hidden max-w-[1300px] mx-auto px-7 mt-32 w-full">
            <Link to={"/calculator"}>
              <div
                style={{ gridTemplateColumns: "45% 25%" }}
                className="md:grid md:-translate-y-[14%] gap-x-16 group"
              >
                <div className="overflow-hidden h-96 border-gradient-2">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={calc}
                  />
                </div>
                <div className="md:mt-14 ">
                  <h3 className="text-4xl  mb-3 text-logo-main pt-5 pb-2 libre">
                    Mortgage Calculator
                  </h3>
                  <span className=" text-logo-main text-lg tracking-wider">
                    Find a price range that works with your budget by using our
                    Mortgage Calculator
                  </span>
                </div>
              </div>
            </Link>
            <Link to={"/real-estate-reports"}>
              <div
                style={{ gridTemplateColumns: "25% 45%" }}
                className="md:grid gap-x-16 justify-end group"
              >
                <div className="md:mt-14 pb-10 text-right">
                  <h3 className="text-4xl  mb-3 text-logo-main pt-5 pb-2 libre">
                    Real Estate Reports
                  </h3>
                  <span className=" text-logo-main text-lg tracking-wider">
                    Gain valuable insights into the market with our free Real
                    Estate Reports
                  </span>
                </div>
                <div className="overflow-hidden h-96 border-gradient-2">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={report}
                  />
                </div>
              </div>
            </Link>
            <Link to={"/evaluation"}>
              <div
                style={{ gridTemplateColumns: "45% 25%" }}
                className="md:grid md:translate-y-[14%] gap-x-16 group"
              >
                <div className="overflow-hidden h-96 border-gradient-2">
                  <img
                    className="h-full w-full object-cover group-hover:scale-105 duration-700"
                    src={house}
                  />
                </div>
                <div className="md:mt-14 pb-10">
                  <h3 className="text-4xl  mb-3 text-logo-main pt-5 pb-2 libre">
                    Home Evaluation
                  </h3>
                  <span className=" text-logo-main text-lg tracking-wider">
                    How much is your home worth in today's market? Find out with
                    our free Home Evaluation
                  </span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div
          ref={contact}
          className="w-full bg-logo-main flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 pt-40 text-black"
        >
          <div>
            <h4 className=" font-semibold text-lg min-w-[20vw]">
              Questions? I'm Here To Help
            </h4>
            <form className="mt-6 flex flex-col">
              <div className="form-item">
                <label className="form-label">Name*</label>
                <input className="form-input" placeholder="Full Name"></input>
              </div>
              <div className="form-item">
                <label className="form-label">Email*</label>
                <input
                  className="form-input"
                  placeholder="Email Address"
                ></input>
              </div>
              <div className="form-item">
                <label className="form-label">Message*</label>
                <textarea
                  className="form-input resize-none h-32"
                  placeholder="Your Message"
                ></textarea>
              </div>
              <button className="btn-secondary self-start  px-10">Send</button>
            </form>
          </div>
          <div>
            <iframe
              class="contact-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.1670922064877!2d-79.3108446!3d43.686289499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cc14ec855631%3A0xb3d0feb68a2d0ed3!2s85%20Cedarvale%20Ave%2C%20Toronto%2C%20ON%20M4C%204J7!5e0!3m2!1sen!2sca!4v1730912488107!5m2!1sen!2sca"
              height="365"
              width={`${windowSize > 900 ? "500" : "300"}`}
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>

            <div className="flex flex-col gap-y-2 mt-6">
              <h2 className="text-2xl">{getCurrentAgentName()}</h2>
              <p className="italic">
                {getCurrentAgentTitle()}, {getCurrentBrokerage()}
              </p>
              <p>
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-logo-third fa-lg"
                />{" "}
                {getCurrentAgentNumber()} {" "}
              </p>
              <p>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="text-logo-third fa-lg"
                />{" "}
                {getCurrentAgentEmail()} {" "}
              </p>
            </div>
          </div>
        </div>
      </div>

      {process.env.NODE_ENV === "development" && (
        <div className="fixed bottom-4 right-4 bg-black bg-opacity-80 text-white p-4 rounded-lg max-w-sm">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-sm font-bold">Global State Debug</h3>
            <button
              onClick={() => setShowDebug(!showDebug)}
              className="text-xs bg-blue-600 px-2 py-1 rounded"
            >
              {showDebug ? "Hide" : "Show"}
            </button>
          </div>
          {showDebug && (
            <div className="text-xs">
              <div>
                <strong>User ID:</strong> {globalState.getUserId() || "Not Set"}
              </div>
              <div>
                <strong>Agent Name:</strong> {getCurrentAgentName()}
              </div>
              <div>
                <strong>Agent Title:</strong> {getCurrentAgentTitle()}
              </div>
              <div>
                <strong>Agent Number:</strong> {getCurrentAgentNumber()}
              </div>
              <div>
                <strong>Agent Email:</strong> {getCurrentAgentEmail()}
              </div>
              <div>
                <strong>Brokerage:</strong> {getCurrentBrokerage()}
              </div>
              <div>
                <strong>User Data:</strong> {globalState.getUserData() ? "Set" : "Not Set"}
              </div>
              <div>
                <strong>Session:</strong> {globalState.getUserData() ? "Saved" : "Not Saved"}
              </div>
              <div>
                <strong>Storage:</strong> sessionStorage
              </div>
              <div className="mt-2 text-xs text-gray-300">
                <div>
                  <strong>Data Flow:</strong>
                </div>
                <div>1. URL UserId → UserData</div>
                <div>2. UserData → getAllUserParams</div>
                <div>3. getAllUserParams → UI</div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
